import React from 'react'
import { observer } from 'mobx-react'
import { TriggerPipelineOnClick } from '@morningtrain/react-helpers'
import PropTypes from 'prop-types'
import { ResetSmartviewOnPipe } from '@morningtrain/react-smartviews'
import DeleteModelPipeline from 'support/pipelines/DeleteModelPipeline'

function DeleteModelOnClick (props) {
  const {
    resetSmartview = false,
    children,
    pipes
  } = props

  return (
    <DeleteModelPipeline {...props}>
      <TriggerPipelineOnClick>
        {children}
      </TriggerPipelineOnClick>
      {resetSmartview ? <ResetSmartviewOnPipe /> : null}
    </DeleteModelPipeline>
  )
}

DeleteModelOnClick.propTypes = {
  resourceName: PropTypes.string,
  modelKey: PropTypes.string,
  resetSmartview: PropTypes.bool,
  afterDeleteOperationName: PropTypes.string,
  afterDeleteResourceName: PropTypes.string,
  pipes: PropTypes.node
}

export default observer(DeleteModelOnClick)
